import * as React from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import Svg, { Defs, ClipPath, Path, G } from 'react-native-svg'

const defaultColor = '#e0a2b3'

export const Bot = ({
  width = 64,
  height = 64,
  color = defaultColor,
  customStyle
}: {
  width?: number
  height?: number
  color?: string
  customStyle?: StyleProp<ViewStyle>
}) => {
  // Per-instance clip id (React.useId returns colons, which are unsafe inside
  // a url(#...) reference, so sanitize them out). A literal id like "a"
  // collides with every other SVG on web, where one page is one DOM and all
  // url(#a) references resolve to the first id="a" in the document.
  const clipId = `bot_${React.useId().replace(/:/g, '')}`
  return (
    <Svg width={width} height={height} viewBox="0 0  85.333336 85.333336" style={customStyle}>
      <Defs>
        <ClipPath id={clipId}>
          <Path d="M0 64h64V0H0z" />
        </ClipPath>
      </Defs>
      <G clipPath={`url(#${clipId})`} transform="matrix(1.33333 0 0 -1.33333 0 85.333)">
        <Path
          d="M0 0c.81.29 1.34 1.04 1.34 1.9v3.81c1.51-1 3.22-1.56 5.03-1.56s3.52.56 5.03 1.56V1.9c0-.86.53-1.61 1.34-1.9l.94-.33c1.82-.64 3.65-1.29 5.46-1.95-2.75-2.51-7.44-4.16-12.76-4.16-5.32 0-10.01 1.64-12.76 4.16C-4.26-1.5-2.13-.75 0 0m-3.52 24.56c.25 1.55.37 3.32.29 4.19.41-.38.86-.76 1.32-1.12C.9 25.45 4.57 23.7 8.42 22.39c-.71-.42-1.24-.97-1.5-1.68-.18.06-.37.09-.55.09-.18 0-.37-.03-.55-.09-.26.75-.84 1.31-1.6 1.74-.87.49-2 .79-3.17.93-1.75.23-3.62.12-4.83-.16.1.41.19.86.26 1.34m.35-2.75c1.05.21 2.58.27 4.03.08.99-.12 1.93-.36 2.62-.75.57-.32.95-.74 1-1.28.04-.42-.12-.86-.29-1.24C3.42 16.87 1.6 15.37-.4 16c-2.58.81-2.83 3.49-2.77 5.81m2.32-7.25c2.95-.93 5.68 1.26 6.62 3.97.09.25.16.53.4.69.13.09.28.09.41 0 .23-.16.3-.44.39-.69.94-2.71 3.67-4.9 6.62-3.97.64.2 1.18.48 1.63.82-.73-1.59-1.57-3.12-2.47-4.45-1-1.47-2.08-2.7-3.19-3.54-.85-.64-2.01-.96-3.19-.96-1.18 0-2.34.32-3.19.96C2.07 8.23.99 9.46 0 10.92c-.91 1.34-1.74 2.86-2.47 4.46.45-.34.98-.62 1.62-.82m10.11 6.58c.41.23.9.4 1.43.54 1.75-.51 3.5-.94 5.21-1.27-.12-1.91-.69-3.76-2.75-4.41-2.03-.64-3.86.9-4.63 2.68-.16.37-.29.78-.26 1.18.05.54.43.96 1 1.28m21.46-31.55c-.42 1.4-.91 2.67-1.5 3.87-.48.97-1.06 1.82-1.78 2.54-.74.73-1.6 1.31-2.63 1.72-1.94.77-3.91 1.49-5.87 2.2 3.33-.48 6.85-.28 8.83 1.49.21.18.23.5.04.7-.18.21-.5.23-.71.05-1.66-1.48-2.94-1-4.34.27-3.8 3.41-3.32 9.38-2.59 13.92.36.44.67.95.93 1.51.52 1.12 1.23 3.77.63 5.09-.15.33-.37.62-.65.86.06 2.31-.17 4.74-.99 7.37-.97 3.08-2.99 5.38-5.52 6.88-2.41 1.43-5.27 2.15-8.14 2.15-2.86 0-5.73-.72-8.14-2.15-2.53-1.5-4.55-3.8-5.52-6.88-.81-2.59-1.05-4.99-.99-7.28a2.5 2.5 0 01-.77-.94c-.6-1.33.12-3.98.63-5.1.3-.63.66-1.2 1.08-1.68.73-4.54 1.14-10.32-2.64-13.73-1.43-1.29-2.73-1.81-4.44-.29-.21.18-.53.16-.71-.05-.18-.2-.17-.52.04-.7 1.98-1.76 5.48-1.97 8.79-1.5-1.94-.71-3.89-1.43-5.82-2.19-1.03-.41-1.9-.99-2.64-1.72-.72-.72-1.3-1.57-1.77-2.54-.6-1.2-1.09-2.47-1.51-3.87-.41-1.38-.75-2.88-1.02-4.57a.995.995 0 01.99-1.15c5.32-.02 9.11-1.06 12.76-2.05 3.57-.98 7.02-1.92 11.62-1.92s8.05.94 11.62 1.92c3.64.99 7.42 2.02 12.72 2.05.07-.01.13 0 .19.01.55.08.92.6.84 1.14-.28 1.69-.61 3.19-1.02 4.57"
          transform="translate(25.63 21.97)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0h-.617c-1.65 0-3 1.35-3 3v5.056c0 1.65 1.35 3 3 3H0c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3"
          transform="translate(17.683 35.644)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0h-.617c-1.65 0-3 1.35-3 3v5.056c0 1.65 1.35 3 3 3H0c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3z"
          transform="translate(17.683 35.644)"
          fill="none"
          stroke="#fff"
          strokeWidth={1}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0h-.617c-1.65 0-3 1.35-3 3v5.056c0 1.65 1.35 3 3 3H0c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3"
          transform="translate(46.403 35.644)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0h-.617c-1.65 0-3 1.35-3 3v5.056c0 1.65 1.35 3 3 3H0c1.65 0 3-1.35 3-3V3c0-1.65-1.35-3-3-3z"
          transform="translate(46.403 35.644)"
          fill="none"
          stroke="#fff"
          strokeWidth={1}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0a1.407 1.407 0 10-2.814 0A1.407 1.407 0 000 0"
          transform="translate(11.932 40.974)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path d="M16.086 40.438h-4.927v1.284h4.927z" fill={color} fillOpacity={1} fillRule="evenodd" stroke="none" />
        <Path
          d="M0 0a.495.495 0 00-.493.493v2.394c0 .271.222.493.493.493a.495.495 0 00.493-.493V.493A.495.495 0 000 0"
          transform="translate(13.834 39.39)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0a1.407 1.407 0 112.814 0A1.407 1.407 0 010 0"
          transform="translate(51.553 40.974)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path d="M47.398 40.438h4.927v1.284h-4.927z" fill={color} fillOpacity={1} fillRule="evenodd" stroke="none" />
        <Path
          d="M0 0c.271 0 .493.222.493.493v2.394A.495.495 0 010 3.38a.495.495 0 01-.493-.493V.493C-.493.222-.271 0 0 0"
          transform="translate(49.65 39.39)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0a1.833 1.833 0 10-3.667 0A1.833 1.833 0 000 0"
          transform="translate(27.95 40.847)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0v-15.891s-1.591-2.314-3.999-2.314"
          transform="translate(37.96 50.72)"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0a1.833 1.833 0 10-3.667 0A1.833 1.833 0 000 0"
          transform="translate(39.54 40.847)"
          fill={color}
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
        />
        <Path
          d="M0 0v-15.891s1.591-2.314 3.999-2.314"
          transform="translate(26.117 50.72)"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0s-1.116-1.855-2.383-2.102c-.596-.247-.99-.267-1.222-.252-.221-.007-.626.005-1.222.252C-6.092-1.855-7.21 0-7.21 0s.894.372 2.235.496C-3.635.618-3.707 0-3.707 0s.052-.32.102-.738c.052.418.104.738.104.738s-.074.618 1.268.496C-.894.372 0 0 0 0"
          transform="translate(35.615 32.923)"
          fill={color}
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
        />
        <Path
          d="M0 0s-1.793-2.367-3.06-2.614c-.596-.247-.991-.267-1.222-.252-.221-.007-.626.005-1.222.252C-6.769-2.367-8.585 0-8.585 0s1.592-.141 2.933-.016c1.34.122 1.268-.496 1.268-.496s.052-.32.102-.739c.052.419.104.739.104.739s-.074.618 1.267.496C-1.571-.141 0 0 0 0"
          transform="translate(36.292 33.945)"
          fill={color}
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
        />
        <Path
          d="M0 0s3.607-1.456 6.702-.029"
          transform="translate(28.649 32.838)"
          fill="none"
          stroke="#fff"
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0v-6.363c0-.809.829-1.671-6.449-4.852"
          transform="translate(30.918 27.174)"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0v-6.363c0-.809-.829-1.671 6.449-4.852"
          transform="translate(33.082 27.174)"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0a.909.909 0 10-1.818 0A.909.909 0 000 0z"
          transform="translate(24.977 18.968)"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
        <Path
          d="M0 0a.909.909 0 10-1.818 0A.909.909 0 000 0z"
          transform="translate(40.965 18.968)"
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={10}
          strokeDasharray="none"
          strokeOpacity={1}
        />
      </G>
    </Svg>
  )
}
